import { Box } from '@mantine/core';
import { clearNotifications, setTalentFilter, selectTalents } from 'modules/Talent/talentSlice';
import { connect, useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import { showNotification } from '@mantine/notifications';
import { useEffect } from 'react';

import { logger } from 'utils/logger';
import LiveFeed from './features/LiveFeed';

const LiveFeedModule = ({ user, guide, guides, selectedTalent, success, error, setTalentFilter, talentFilter }) => {
    const dispatch = useDispatch();

    // SUCCESS AND ERROR HANDLERS
    useEffect(() => {
        logger.log(success);
        if (error) {
            showNotification({
                title: 'Whoops something went wrong.',
                message: error.message,
                position: 'top-center',
                color: 'red',
            });

            dispatch(clearNotifications());
        }

        if (success) {
            switch (success.type) {
                
                default: {
                    break;
                }
            }
        }

        // if the session has been created then we load the session detail view
    }, [error, success, dispatch]);

    return (
        <Box
            id='liveFeedModule'
            style={(theme) => ({
                // backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.white,
                width: '100%',
                height:'100%'
            })}>
            
                <Routes>
                    <Route path='/' element={<LiveFeed />}></Route>
                    {/* <Route path='/:id' element={<LiveFeedAssetView />}></Route> */}
                </Routes>
            
        </Box>
    );
};

const mapStateToProps = (state, props) => {
    //logger.log(state,props, ' mapstate')
    return {
        user: state.auth.user,
        talentFilter: state.talentReducer.talentFilter,
        selectedTalents: state.talentReducer.selectedTalents,
        talent: state.talentReducer.selectedTalent,
        success: state.talentReducer.success,
        displayPrefs: state.talentReducer.displayPrefs,
        error: state.talentReducer.error,
    };
};

const mapDispatchToProps = { setTalentFilter, selectTalents };

export default connect(mapStateToProps, mapDispatchToProps)(LiveFeedModule);
